export default "__VITE_ASSET__96bc63d7__"